import { render, staticRenderFns } from "./TipInput.vue?vue&type=template&id=55db6dfa&"
import script from "./TipInput.vue?vue&type=script&lang=js&"
export * from "./TipInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55db6dfa')) {
      api.createRecord('55db6dfa', component.options)
    } else {
      api.reload('55db6dfa', component.options)
    }
    module.hot.accept("./TipInput.vue?vue&type=template&id=55db6dfa&", function () {
      api.rerender('55db6dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/TipInput.vue"
export default component.exports